import { GlSprintf } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'IssueCount',
    components: {
        GlSprintf
    },
    props: {
        maxCount: {
            type: Number,
            required: false,
            default: 0
        },
        currentCount: {
            type: Number,
            required: true
        }
    },
    computed: {
        isMaxLimitSet () {
            return this.maxCount !== 0;
        },
        exceedsMax () {
            return this.isMaxLimitSet && this.currentCount > this.maxCount;
        }
    }
};
